import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-ballet-canvas px-4 py-20 sm:py-28" data-id="element-130" data-mp="1o2vhap4uen6k">
      <motion.div initial={{
      opacity: 0,
      scale: 0.98
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="relative mx-auto max-w-4xl overflow-hidden rounded-3xl border border-ballet-gold/65 bg-white p-8 text-center shadow-soft sm:p-12" data-id="element-131" data-mp="223y6har4wdlp">
        <div className="absolute inset-x-0 top-0 h-1 bg-ballet-gold" data-id="element-132" data-mp="1j4k5w9ywg4m8" />
        <span className="mx-auto inline-flex h-20 w-20 items-center justify-center rounded-full border border-ballet-gold/60 bg-ballet-goldSoft text-ballet-gold" data-id="element-133" data-mp="1j5vcehjqbqh1">
          <ShieldCheckIcon size={40} data-id="element-134" data-mp="qn7u19w4apjn" />
        </span>
        <h2 className="mt-6 font-display text-5xl font-semibold text-ballet-ink" data-id="element-135" data-mp="qlws7fm8frv6">
          Complete 7-Day Guarantee
        </h2>
        <div className="mx-auto mt-7 max-w-2xl space-y-5 text-base leading-7 text-ballet-muted" data-id="element-136" data-mp="p01j2cs0vbcd">
          <p data-id="element-137" data-mp="ty2xulif0oi1">
            Open the complete teaching library. Explore the 5 bonuses. Use the
            material in your most demanding class this week.
          </p>
          <p className="font-semibold text-ballet-ink" data-id="element-138" data-mp="yrp2pric7o3a">
            If you feel the material is not clear, practical, or useful for your
            teaching needs—contact us within 7 days.
          </p>
          <p className="font-display text-3xl font-semibold text-ballet-rose" data-id="element-139" data-mp="63072801wayx">
            We will refund 100% of your money. No questions. No forms. No
            complications.
          </p>
          <p className="pt-2 text-sm" data-id="element-140" data-mp="f3opdewh8xhm">
            Because if the material does not deliver the value we promise, we do
            not want to keep your money.
          </p>
        </div>
      </motion.div>
    </section>;
}